export enum InvoiceItemCategory {
  commodity = 'commo',
  grid = 'grid',
  tax = 'tax',
  misc = 'misc',
  service = 'service',
}

export const getInvoiceItemCategoryFromValue = (value): InvoiceItemCategory => {
  const index = Object.values(InvoiceItemCategory).indexOf(value);
  if (index < 0) {
    throw new Error('Unknown invoice item category ' + value);
  }

  return Object.keys(InvoiceItemCategory)[index] as InvoiceItemCategory;
};
